export const isNodeExpanded = node => node.isopen;
export const nodeHasChildren = node =>
  ("isLeaf" in node && !node.isLeaf) || (node.childs && node.childs.length);

export const getFlattenedTree = (nodes, parents = [], mainKey) =>
  nodes.reduce((flattenedTree, node) => {
    const deepness = parents.length;
    const nodeWithHelpers = { ...node, deepness, parents };

    if (!nodeHasChildren(node) || !isNodeExpanded(node)) {
      return [...flattenedTree, nodeWithHelpers];
    }

    return [
      ...flattenedTree,
      nodeWithHelpers,
      ...getFlattenedTree(
        Array.isArray(node.childs)
          ? node.childs
          : node.childs && node.childs.datas,
        [...parents, node[mainKey]]
      )
    ];
  }, []);

export const getFlattenedTreePaths = (nodes, parents = []) => {
  const paths = [];

  for (const node of nodes) {
    const domid = node[mainKey];

    if (!nodeHasChildren(node) || !isNodeExpanded(node)) {
      paths.push(parents.concat(domid));
    } else {
      paths.push(parents.concat(domid));
      paths.push(...getFlattenedTreePaths(node.childs, [...parents, domid]));
    }
  }

  return paths;
};

export const doesChangeAffectFlattenedTree = (previousNode, nextNode) => {
  return isNodeExpanded(previousNode) !== isNodeExpanded(nextNode);
};



// WEBPACK FOOTER //
// ./ecology9/wea-tree-test/react-virtualized-tree/src/selectors/getFlattenedTree.js